import { render, staticRenderFns } from "./TabelaDeVinculos.vue?vue&type=template&id=44912ef7&scoped=true"
import script from "./TabelaDeVinculos.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeVinculos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeVinculos.vue?vue&type=style&index=0&id=44912ef7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44912ef7",
  null
  
)

export default component.exports